module.exports = __webpack_public_path__ + "494aab30a65c7c4042935189389c66e3.svg";